<template>
  <div>
    <Header />
    <div class="pt80">
      <div id="section1">
        <div class="container">
          <div class="th">{{ $t("conUs.th") }}</div>
        </div>
      </div>
      <div id="section2">
        <div class="container d-flex">
          <img src="@/assets/con-2.png" width="307px" class="pic" />
          <div class="formBox">
            <el-form ref="ruleForm" :model="form" label-position="top">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('conUs.lastName')"
                    prop="lastName"
                    :rules="[
                      {
                        required: true,
                        message: $t('error.lastName'),
                        trigger: 'blur'
                      }
                    ]"
                  >
                    <el-input
                      v-model="form.lastName"
                      :placeholder="$t('conUs.phr1')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('conUs.firstName')"
                    prop="firstName"
                    :rules="[
                      {
                        required: true,
                        message: $t('error.firstName'),
                        trigger: 'blur'
                      }
                    ]"
                  >
                    <el-input
                      v-model="form.firstName"
                      :placeholder="$t('conUs.phr2')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item
                :label="$t('conUs.email')"
                prop="email"
                :rules="[
                  {
                    required: true,
                    message: $t('error.email'),
                    trigger: 'blur'
                  },
                  {
                    type: 'email',
                    message: $t('error.email'),
                    trigger: ['blur', 'change']
                  }
                ]"
              >
                <el-input
                  v-model="form.email"
                  :placeholder="$t('conUs.phr3')"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('conUs.phone')"
                prop="pInfo"
                :rules="[
                  {
                    type: 'object',
                    required: true,
                    trigger: 'change',
                    fields: {
                      phone: {
                        required: true,
                        message: $t('error.phone'),
                        trigger: 'blur'
                      },
                      area: {
                        required: true,
                        message: $t('error.area'),
                        trigger: 'change'
                      }
                    }
                  }
                ]"
              >
                <el-input
                  v-model="form.pInfo.phone"
                  :placeholder="$t('conUs.phr4')"
                >
                  <el-select
                    v-model="form.pInfo.area"
                    slot="prepend"
                    :placeholder="$t('conUs.phr5')"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="(a, index) in area"
                      :key="index"
                      :label="a.code + a.cn"
                      :value="a.code"
                    ></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item
                :label="$t('conUs.companyName')"
                prop="companyName"
                :rules="[
                  {
                    required: true,
                    message: $t('error.companyName'),
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="form.companyName"
                  :placeholder="$t('conUs.phr6')"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('conUs.companyAddress')"
                prop="companyAddress"
              >
                <el-input
                  v-model="form.companyAddress"
                  :placeholder="$t('conUs.phr7')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div class="d-flex">
                  <el-checkbox v-model="checked"></el-checkbox>
                  <div style="margin-left: 6px; color: #606266">
                    {{ $t("conUs.check1")
                    }}<span
                      style="color: #1485ef; cursor: pointer"
                      @click="toPrivacy"
                      >{{ $t("conUs.check2") }}</span
                    >{{ $t("conUs.check3") }}
                  </div>
                </div>
              </el-form-item>
              <div class="btnBox">
                <el-button class="btn" type="primary" @click="onSubmit">{{
                  $t("conUs.submit")
                }}</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
const crypto = require("crypto"); // 引入加密库
const axios = require("axios"); // 引入HTTP客户端

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import area from "./area.js";
// import { MsgSend } from "@/api/url";
// import { hex, sign } from "@/utils/HMAC-SHA256";
export default {
  name: "personal",
  components: { Header, Footer },
  data() {
    return {
      area: area,
      form: {
        firstName: "",
        lastName: "",
        email: ``,
        pInfo: { phone: "", area: "" },
        companyName: "",
        companyAddress: ""
      },
      checked: false
    };
  },
  mounted() {},
  methods: {
    // 生成签名
    sign(timestamp, secret) {
      const stringToSign = `${timestamp}\n${secret}`;
      const hmac = crypto.createHmac("sha256", secret.trim());
      hmac.update(stringToSign);
      return encodeURIComponent(hmac.digest("base64"));
    },
    // 发送消息
    sendMessage(accessToken, timestamp, signature) {
      const send_msg_url = `/api/robot/send?access_token=${accessToken}&timestamp=${timestamp}&sign=${signature}`;
      const data = {
        // 消息内容，根据需要设定
        text: {
          content:
            `【企业入驻】姓：${this.form.firstName} 名：${this.form.lastName}；邮箱: ${this.form.email}；` +
            `区号：${this.form.pInfo.area}；办公电话：${this.form.pInfo.phone}；公司名称：${this.form.companyName}；公司主要业务地区：${this.form.companyAddress}`
        },
        // 消息类型，这里以text为例
        msgtype: "text"
      };

      axios
        .post(send_msg_url, data, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          console.log("Message sent:", response.data);
          if (response.data.errcode == 0) {
            this.$message({ message: "提交成功", type: "success" });
          }
        })
        .catch(error => {
          console.error("Error sending message:", error);
        });
    },
    onSubmit() {
      if (!this.checked) {
        this.$message({
          message: this.$t("error.checked"),
          type: "warning"
        });
        return;
      }
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const accessToken =
            "bb1dae08725b51efac44ea884e012e9aa3a72da00b0ca1fdf9a8c4b899a9ed5a";
          const timestamp = new Date().getTime();
          const signature = this.sign(
            timestamp,
            "SECab113a2c5a1cd723e5eb05678a32cf914155290b7e345e305be6e01edec56f0a"
          );
          this.sendMessage(accessToken, timestamp, signature);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toPrivacy() {
      this.$router.push("/privacyPolicy");
      // const url =
      //   "https://dashboard.zantechglobal.com/#/privacyPolicy?lang=zh-CN";
      // window.open(url);
    }
  }
};
</script>

<style lang="less" scoped>
.pt80 {
  padding-top: 80px;
}

.container {
  padding: 0;
}

#section1 {
  height: 144px;
  background-image: url(~@/assets/con-1.png);
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  .container {
    position: relative;
  }
  .th {
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 144px;
  }
}

/deep/ .el-form-item__label {
  padding: 0 !important;
}

#section2 {
  min-height: calc(100vh - 400px);
  padding-bottom: 200px;
  .pic {
    margin-left: 0px;
    margin-top: 61px;
    height: 100%;
  }
}
.formBox {
  margin-top: 50px;
  margin-left: 20px;
  width: 500px;
  .btnBox {
    width: 100%;
    .btn {
      display: block;
      margin: 20px auto;
      width: 210px;
      height: 40px;
      background: #1485ef;
      border-radius: 163px 163px 163px 163px;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/contact-us.vue